// src/components/common/Loading.jsx
import React from 'react';
import { Loader2 } from 'lucide-react';

const Loading = ({ message = 'Chargement...', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600 font-medium">{message}</p>
        </div>
      </div>
    );
  }

  return (<div className="flex items-center justify-center py-12">
    <div className="text-center">
      <Loader2 className="w-10 h-10 text-primary-600 animate-spin mx-auto mb-3" />
      <p className="text-gray-600 text-sm">{message}</p>
    </div>
  </div>
);
};

export default Loading;